// constants
export const SESSION_SEPERATOR = '~';
export const NYKAA_ANALYTICS_CACHE_KEY = 'NYKAA_AC';
export const OMNITURE_MC_ID_KEY = 'mcid';
export const NYKAA_VISITOR_ID_COOKIE = 'bcookie';
export const NYKAA_VISIT_ID_COOKIE = 'NYK_VISIT';
export const NYKAA_PAGE_COUNTER_COOKIE = 'NYK_PCOUNTER';
export const NYKAA_PAGE_COUNTER_EXPIRY_DAYS = 365;
export const NYKAA_EVENT_COUNTER_COOKIE = 'NYK_ECOUNTER';
export const NYKAA_EVENT_COUNTER_EXPIRY_DAYS = 365;
export const PAGE_LOAD_EVENT_NAME = 'page_load';
export const CATEGORY_PAGE_TYPE = 'Category Page L0';
export const OFFER_LISTING_PAGE_TYPE = 'Offer Listing';
export const CMS_PAGE_TYPE = 'CMS Page';
export const HOME_PAGE_TYPE = 'Nykaa : Home Page';
export const PRODUCT_PAGE_TYPE = 'Product Detail Page';
export const SEARCH_PAGE_TYPE = 'Search Page';
export const BANNER_CLICK_EVENT = 'banner_click';
export const BANNER_IMPRESSION_EVENT = 'banner_impression';
export const DEFAULT_EVENT_THRESHOLD = 20;
export const PAGE_TYPE_MAP = {
    CATEGORY_PAGE: CATEGORY_PAGE_TYPE,
    CMS_PAGE: CMS_PAGE_TYPE,
    HOME_PAGE: HOME_PAGE_TYPE,
    PRODUCT_PAGE: PRODUCT_PAGE_TYPE,
    SEARCH_PAGE: SEARCH_PAGE_TYPE,
    OFFER_LISTING_PAGE: OFFER_LISTING_PAGE_TYPE,
};
export const NLP_PAGE_NAME_PREFIX = ['mWeb:nlp', 'desktop:nlp'];
export const LISTING_PAGES_ARRAY = ['search_listing', 'category_listing', 'brand_listing', 'offer_listing'];
